var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_filled",
    d: "M21.26 11.29c-7.519 0-13.852 4.214-15.807 9.973 1.964 5.752 8.296 9.965 15.807 9.965s13.843-4.213 15.807-9.965c-1.955-5.76-8.288-9.973-15.807-9.973zm0 15.876a5.783 5.783 0 110-11.566 5.783 5.783 0 010 11.566z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 21.26,
    cy: 21.336,
    r: 5.783
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 21.26,
    cy: 21.608,
    r: 1.752
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibleFilled);
export default __webpack_public_path__ + "static/media/visibleFilled.c7fbf07fd98ff5044e95510949b51184.svg";
export { ForwardRef as ReactComponent };